import styled from 'styled-components';

export const BaseModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column; 
  flex: 1;
  overflow-y: scroll;
`;

const defaultMaxPageWidth = '800px';
export const PageContainer = styled.div<{
    maxWidth?: string;
}>`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  margin: 0 40px;
  max-width: ${({ maxWidth = defaultMaxPageWidth }) => maxWidth};
  @media (max-width: 500px) {
    margin: 0 2px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/container-styles.tsx